import * as React from "react";
import { Product, FieldValueMedia } from "typings/index";
import { formatFilePath } from "~/util/media";
import { BaseMedia } from "typings/media";
import { getProductName } from "~/util/productHelper";

export interface Props 
{
    product: Product;
    files: BaseMedia[];
}


const SimpleProduct: React.FunctionComponent<Props> = props =>
{
    const { product, files } = props;
    const title = getProductName(product);
    const label = <h5>{title}</h5>;
    let content = null;
    if (product.data.images)
    {
        const image = product.data.images as FieldValueMedia;
        if (image.value && image.value.length > 0)
        {
            const media = files.find(x => image.value && x.id === image.value[0]);
            if (media && media.data.orginalFilePath)
            {
                content = <img src={`${formatFilePath(media.data.orginalFilePath.value)}`} />;

            }
        }
    }

    return (
        <a  title={title} >
            {content}
            {label}
        </a>
    );
};



export default SimpleProduct;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/productPicker/SimpleProduct.tsx